import { LegendItemBadgeShape_$type } from "igniteui-react-core";
import { DataLegendStylingRowEventArgs as DataLegendStylingRowEventArgs_internal } from "./DataLegendStylingRowEventArgs";
import { ensureEnum, ensureBool, brushToString, stringToBrush } from "igniteui-react-core";
/**
 * Represents styling event args for a row in data legend
*/
var IgrDataLegendStylingRowEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrDataLegendStylingRowEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
        if (this._initializeAdapters) {
            this._initializeAdapters();
        }
    }
    IgrDataLegendStylingRowEventArgs.prototype.createImplementation = function () {
        return new DataLegendStylingRowEventArgs_internal();
    };
    Object.defineProperty(IgrDataLegendStylingRowEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrDataLegendStylingRowEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrDataLegendStylingRowEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
        if (this._initializeAdapters) {
            this._initializeAdapters();
        }
    };
    Object.defineProperty(IgrDataLegendStylingRowEventArgs.prototype, "badgeShape", {
        /**
         * Gets or sets shape of legend badge in the Data Legend
         * This setting applies only to styling series rows
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = ensureEnum(LegendItemBadgeShape_$type, v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendStylingRowEventArgs.prototype, "isBadgeVisible", {
        /**
         * Gets or sets whether the legend badge is visible in the Data Legend
         * This setting applies only to styling series rows
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendStylingRowEventArgs.prototype, "isRowVisible", {
        /**
         * Gets or sets whether the whole row is visible in the Data Legend
        */
        get: function () {
            return this.i.c;
        },
        set: function (v) {
            this.i.c = ensureBool(v);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendStylingRowEventArgs.prototype, "seriesIndex", {
        /**
         * Gets index of series in the chart
        */
        get: function () {
            return this.i.d;
        },
        set: function (v) {
            this.i.d = +v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendStylingRowEventArgs.prototype, "seriesTitle", {
        /**
         * Gets title of series in the chart
        */
        get: function () {
            return this.i.e;
        },
        set: function (v) {
            this.i.e = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendStylingRowEventArgs.prototype, "titleText", {
        /**
         * Gets or sets title text displayed in row of Data Legend
        */
        get: function () {
            return this.i.f;
        },
        set: function (v) {
            this.i.f = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrDataLegendStylingRowEventArgs.prototype, "titleTextColor", {
        /**
         * Gets or sets color of title text
        */
        get: function () {
            return brushToString(this.i.g);
        },
        set: function (v) {
            this.i.g = stringToBrush(v);
        },
        enumerable: false,
        configurable: true
    });
    return IgrDataLegendStylingRowEventArgs;
}());
export { IgrDataLegendStylingRowEventArgs };
